module.exports = __webpack_public_path__ + "static/dev-a427e194bf952a606d82f865a3afb49e.svg";